<div class="main-content">
  <app-header
    [title]="'HEADER.TITLE_LEGAL_DOCUMENTS' | translate"
    [subtitle]="'HEADER.SUBTITLE_LEGAL_DOCUMENTS' | translate"
  />

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end">
      <button class="preview-button" [routerLink]="['/legal-documents', 'preview']">
        {{ 'LEGAL_DOCUMENTS.PREVIEW_BUTTON' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'repository'" [iconColor]="'white'">
        <app-table [allValues$]="legalDocuments$" [type]="'legal_documents'" [hasChart]="false" [showTitle]="false" />
      </app-icam-container>
    </div>
  </div>
</div>
<app-footer-copyright />
